import React from "react";
import { Button } from "semantic-ui-react";

import "./index.scss";

export default props => <Button icon="cancel" className="CancelButton" {...props} />;
